var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gender-data"},[_c('div',{ref:"terBroEchart",style:({ height: '240px', width: '100%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }